import React from "react";
import AlertPanel from "../components/dashboard/alertPanel";
import DownloadPanel from "../components/dashboard/downloadPanel";
import {Grid} from "@mui/material";
import TrafficCountChart from "../components/dashboard/trafficCountChart";

export default function Dashboard() {
    return <Grid container spacing={3} alignItems="stretch" justifyContent="center"
                 sx={{margin: 'auto', mt: 10, width: '97%'}}>
        <Grid size={{xs: 12, md: 6, lg: 7, xl: 8}} sx={{minHeight: '600px', maxHeight: '800px'}}>
            <AlertPanel/>
        </Grid>

        <Grid size={{xs: 12, md: 6, lg: 5, xl: 4}} sx={{minHeight: '600px', maxHeight: '800px'}}>
            <DownloadPanel/>
        </Grid>
        <Grid size={12} sx={{minHeight: '400px', maxHeight: '1000px'}}>
            <TrafficCountChart/>
        </Grid>
    </Grid>
}